<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <label for="fromDate">As On</label>
              <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">Store</label>
              <Dropdown
                v-if="!setWarehouseData"
                v-model="warehouseId"
                :options="warehouseLists"
                optionLabel="name"
                id="warehouse"
                :filter="true"
                placeholder="Select store"
                :showClear="true"
              />
              <Dropdown
                v-if="setWarehouseData"
                v-model="warehouseId"
                :options="warehouseLists"
                optionLabel="name"
                id="warehouse"
                :filter="true"
                placeholder="Select store"
                :disabled="true"
              />
            </div>
            <div class="p-field p-col-12 p-md-2 p-mt-5">
              <Button @click.prevent="searchDailySalesReport"
                      class="p-button-raised" label="Search" icon="pi pi-search"/>
            </div>
            <div class="p-field p-col-12 p-md-2 p-mt-5">
              <Button @click.prevent="reset"
                      class="p-button-raised p-button-warning" icon="pi pi-refresh" label="Reset"/>
            </div>
          </div>
        </form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-col-12">
            <a href="#" class="p-field p-col-12 p-md-12" @click.prevent="exportCSV()">
              <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
            </a>
            <DataTable :value="dailySalestList"
                       ref="po"
                       :rowsPerPageOptions="[100,500,1000]"
                       :rows="100" :filters="filters"
                       :paginator="true"
                       class="p-datatable-responsive p-datatable-gridlines"
                       data-key="id">
              <Column header="S.N">
                <template #body="sl">{{ sl.index + 1 }}</template>
              </Column>
              <Column header="Item Name" :sortable="true" field="itemName" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['salesDateNepali']"/>
                </template>
                <template #footer>
                  Total:
                </template>
              </Column>
              <Column header="Item Code" :sortable="true" field="itemCode" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['itemCode']"/>
                </template>
              </Column>
              <Column header="Unit" :sortable="true" field="unitName" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['unitName']"/>
                </template>
              </Column>
              <Column header="Sales Qty" :sortable="true" field="salesQty" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['salesQty']"/>
                </template>
                <template #footer>
                  {{ totalQuantity.toFixed(2) }}
                </template>
              </Column>
              <template #empty>No record found</template>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import InputMask from 'primevue/inputmask'
import Dropdown from 'primevue/dropdown'

export default {
  name: 'DailySalesReport',
  data() {
    return {
      fromDate: null,
      loading: false,
      dialogShow: false,
      columnList: '',
      filters: {},
      setWarehouseData: false,
      englishDateEnabled: true,
      dailySalestList: [],
      enableEdit: false,
      enableDelete: false,
      warehouseId: '',
      totalQuantity: 0
    }
  },
  computed: {
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
    this.warehouseList()
    this.setWarehouse()
    this.totalBalance()
  },
  methods: {
    async searchDailySalesReport() {
      if (this.warehouseId !== '' && this.warehouseId !== null) {
        this.id = this.warehouseId.id
      } else {
        this.id = '0'
      }
      let dat = {
        warehouse: this.id,
        fromDate: this.fromDate
      }
      this.loading = true
      let response = await this.$store.dispatch('loadDailySalesReport', dat)
      this.loading = false
      if (response.data.status === 'SUCCESS') {
        this.dailySalestList = response.data.data
        if (this.dailySalestList.length === 0) {
          this.$toast.add({
            severity: 'warn',
            summary: '',
            detail: 'No list available!',
            life: 3000
          })
          return
        }
        this.$toast.add({
          severity: 'success',
          summary: '',
          detail: response.data.message,
          life: 3000
        })
        this.totalBalance()
        return
      }
    },
    // async viewPOSSalesDetail(data) {
    //   let SalesDetail = {
    //     returningAmount: data.returningAmount,
    //     contactNumber: data.contactNumber,
    //     billPrefix: data.billPrefix,
    //     billNo: data.billNo,
    //     paymentMethod: data.paymentMethod,
    //     salesDateNepali: data.salesDateNepali,
    //     subTotalAmount: data.subTotal,
    //     nonTaxableAmount: data.nonTaxableAmount,
    //     taxableAmount: data.taxableAmount,
    //     vatAmount: data.vatAmount,
    //     billAmount: data.billAmount,
    //     vatTypeEnum: data.vatTypeEnum,
    //     tenderAmount: data.tenderAmount,
    //     discountAmt: data.discountAmount,
    //     childSalesDetailsDTOList: data.childSalesDetailsDTOList
    //   }
    //   this.$router.push({name: 'Unsettled Details', params: { UnsettledData: SalesDetail }})
    // },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReport/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.fromDate + '/dailySalesInvoice' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'salesInvoice.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    totalBalance() {
      this.totalQuantity = 0.0
      for (let sale of this.dailySalestList) {
        this.totalQuantity += sale.salesQty
      }
    },
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouseId = this.$store.state.warehouseData
      } else if (this.warehouseLists.length === 1) {
        this.warehouseId = this.warehouseLists[0]
      }
    },
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    exportToPdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/printSalesBill/' + SOHeaderId + '/salesInvoice' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'salesInvoice.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    checkEnableEdit() {
      if (this.$store.getters.modules.includes(',5.08')) {
        this.enableEdit = true
      }
    },
    checkEnableDelete() {
      if (this.$store.getters.modules.includes(',5.13')) {
        this.enableDelete = true
      }
    },
    // async editSalesInvoice(data) {
    //   this.$router.push({name: 'Sales Invoice', params: {salesInvoice: data}})
    // },
    // async deleteReport(value) {
    //   if (value.trim() === '') {
    //     this.$toast.add({severity: 'success', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
    //     this.dialogShow = true
    //     return
    //   }
    //   let deleteRe = {
    //     inventoryOutHeaderId: this.accountId,
    //     deleteReason: value
    //   }
    //   let resp = await this.$store.dispatch('deleteSalesInvoice', deleteRe)
    //   if (resp.data.status === 'SUCCESS') {
    //     this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
    //   } else {
    //     this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
    //   }
    //   this.dialogShow = false
    // },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    reset() {
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.setEnglishDate()
      }
      window.location.reload()
    },
    // cancel(data) {
    //   this.dialogShow = false
    // },
    // openDialog(id) {
    //   this.dialogShow = true
    //   this.accountId = id
    // },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    Dialog,
    InputText,
    Button,
    InputMask,
    Dropdown
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// dailySalesReport.vue?6594ee7e